import { DateFormatDefaults as GBUIDateFormatDefaults } from '@groupby/ui-components';
export var Localization;
(function (Localization) {
    Localization.DateFormatDefaults = GBUIDateFormatDefaults;
    Localization.TimeFormat = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23',
    };
    Localization.DateTimeFormat = Object.assign(Object.assign({}, Localization.DateFormatDefaults), Localization.TimeFormat);
    /**
     * Human-facing schedule display format — matches the 12-hour AM/PM input used in
     * date-time pickers (no seconds, no timezone, locale-default hour cycle).
     * Example (en-US): "Sep 14, 2023, 12:00 AM"
     */
    Localization.DisplayDateTimeFormat = Object.assign(Object.assign({}, Localization.DateFormatDefaults), { hour: 'numeric', minute: 'numeric' });
    /**
     * Fully-spelled-out, locale-aware date — for screen-reader-facing labels
     * (e.g. a calendar day cell's accessible name) rather than compact display.
     * Example (en-US): "Wednesday, September 16, 2026"
     */
    Localization.AccessibleFullDateFormat = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    Localization.SupportedLanguages = {
        ENGLISH_US: 'en-US',
        SIMPLIFIED_CHINESE: 'zh',
        SPANISH: 'es',
        FRENCH: 'fr',
        GERMAN: 'de',
        ITALIAN: 'it',
        DUTCH: 'nl',
        JAPANESE: 'ja',
        PORTUGUESE_BRAZIL: 'pt-BR',
    };
    Localization.QALanguage = {
        EMOJI: 'qem',
    };
    Localization.DEFAULT_LANGUAGE_CODE = Localization.SupportedLanguages.ENGLISH_US;
    Localization.ShortDateFormat = {
        month: 'short',
        day: 'numeric',
    };
    Localization.ShortDateUTCFormat = Object.assign(Object.assign({}, Localization.ShortDateFormat), { timeZone: 'UTC' });
    Localization.DateUTCFormatDefaults = Object.assign(Object.assign({}, Localization.DateFormatDefaults), { timeZone: 'UTC' });
})(Localization || (Localization = {}));
export var CURRENCY;
(function (CURRENCY) {
    CURRENCY["AUD"] = "AUD";
    CURRENCY["EUR"] = "EUR";
    CURRENCY["GBP"] = "GBP";
    CURRENCY["JPY"] = "JPY";
    CURRENCY["USD"] = "USD";
})(CURRENCY || (CURRENCY = {}));
export const compactNumberFormatOptions = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: 'compact',
};
export const standardCurrencyFormatOptions = {
    notation: 'standard',
    maximumFractionDigits: 0,
};
export const getCodeToLanguage = () => ({
    [Localization.SupportedLanguages.ENGLISH_US]: 'English',
    [Localization.SupportedLanguages.SIMPLIFIED_CHINESE]: '中文',
    [Localization.SupportedLanguages.SPANISH]: 'Español',
    [Localization.SupportedLanguages.PORTUGUESE_BRAZIL]: 'Português (Brasil)',
    [Localization.SupportedLanguages.FRENCH]: 'Français',
    [Localization.SupportedLanguages.GERMAN]: 'Deutsch',
    [Localization.SupportedLanguages.ITALIAN]: 'Italiano',
    [Localization.SupportedLanguages.DUTCH]: 'Nederlands',
    [Localization.SupportedLanguages.JAPANESE]: '日本語',
});
export const YEAR_MONTH_DAY_FORMAT = { year: 'numeric', month: 'numeric', day: 'numeric' };
